import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { Button, Input, Popover, PopoverContent, PopoverTrigger, Separator, } from '@cargomatic/ui';
import { Badge } from 'components/design-system/molecules/badge-fix';
/**
 * Text input filter with badge display for added values.
 * Opens a popover with an input + Add button. Shows added items as badges.
 */
export function FilterTextInput({ placeholder, values, onAdd, onRemove, onClear, addLabel, badgeSuffix, }) {
    const [input, setInput] = useState('');
    const count = values.length;
    const handleAdd = () => {
        const trimmed = input.trim();
        if (trimmed && !values.includes(trimmed)) {
            onAdd(trimmed);
            setInput('');
        }
    };
    return (React.createElement(Popover, null,
        React.createElement(PopoverTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: "sm", className: "w-full justify-start px-2 font-normal h-8 border-dashed" },
                React.createElement(Search, { className: "size-3 text-muted-foreground shrink-0" }),
                count > 0 ? (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { orientation: "vertical", className: "mx-1.5 h-4" }),
                    React.createElement(Badge, { className: "rounded-sm px-1 font-normal" },
                        count,
                        " ",
                        badgeSuffix || 'selected'))) : (React.createElement("span", { className: "text-muted-foreground truncate text-xs ml-1" }, placeholder)))),
        React.createElement(PopoverContent, { className: "w-[280px] p-2", align: "start" },
            React.createElement("div", { className: "flex gap-1.5 mb-2" },
                React.createElement(Input, { placeholder: placeholder, value: input, onChange: (e) => setInput(e.target.value), onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAdd();
                        }
                    }, className: "h-8 text-sm" }),
                React.createElement(Button, { size: "sm", className: "h-8 shrink-0", onClick: handleAdd }, addLabel || 'Add')),
            count > 0 && (React.createElement("div", { className: "flex flex-wrap gap-1 mb-2" }, values.map((val) => (React.createElement(Badge, { key: val, variant: "secondary", className: "gap-0.5 pr-0.5 text-xs" },
                val,
                React.createElement("button", { type: "button", className: "inline-flex items-center justify-center size-3 shrink-0 cursor-pointer", "aria-label": `Remove ${val}`, onClick: () => onRemove(val) },
                    React.createElement(X, { className: "size-3" }))))))),
            count > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "border-t my-1" }),
                React.createElement("button", { type: "button", className: "w-full text-center text-xs text-muted-foreground hover:text-foreground py-1 cursor-pointer", onClick: onClear }, "Clear all"))))));
}
